import Button from "@app/components/button"
import GradientContainer from "@app/components/gradient/gradient-container"
import TextGradient from "@app/components/gradient/gradient-text"
import { useState } from "react";

/* eslint-disable @next/next/no-img-element */
const DesktopHospitalityVenue = ({ inView3 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div>
      <div
        className={`shadow-lg-light absolute bg-opacity-50 mt-5 ml-16 xl:mt-16 xl:ml-24 bg-black 
          w-[60%] xl:w-[45%] 2xl:w-[35%] rounded-2xl p-6`}
        style={{
          visibility: inView3 ? 'visible' : 'hidden',
          transform: inView3 ? 'translateX(0%)' : 'translateX(-10%)',
          transition: 'transform 500ms ease-in',
          // opacity: inView2 ? 0.9 : 0,
        }}
      >
        <div
          className={`flex flex-col ml-2 space-y-5 
          ${isExpanded ? 'h-[480px]  xl:h-[570px] xl-2:!h-[540px] 2xl:!h-[590px]' : 'h-[345px] xl:h-[360px] xl-2:!h-[335px] 2xl:!h-[355px]'}
           transition-[height] ease-out duration-500`}
        >
          <TextGradient>
            <p className="h2">03</p>
          </TextGradient>
          <p className="h4 xl:h3 text-light">Hospitality & Venue​</p>
          <div>
            <GradientContainer overrideClassName="w-[40%] h-2" />
          </div>
          <div className="subheading text-light space-y-5">
            <p>
              Our unique service model and technology platform are ideal for
              operators of restaurants, hotels, casinos, entertainment venues,
              gaming establishments, golf
              & country clubs, resorts, and more!
            </p>

            {isExpanded && (
              <div className="space-y-5">
                <p>
                  We combine all aspects of procurement, technology, and support to
                  provide your business with the best pricing, guaranteed. Optimize your operations,
                  administration, and purchasing through our Sole Source User Interface.
                </p>
                <p className="hidden xl:block">
                  Immediate savings are available through the SimpleWaste
                  technology platform.
                </p>
              </div>
            )}
          </div>
          <div className="flex h-full items-end">
            <div>
              <Button onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? 'Read less' : 'Read more'}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <img
          src="/images/industries/hospitality.png"
          alt="hospitality"
        />
      </div>
    </div>
  )
}

export default DesktopHospitalityVenue;
